import React, { Component, PropTypes } from 'react';
import axios from 'axios';

import { render } from 'react-dom';

import PlaceModal from '../components/place-modal';

const breakpoint = 768;

export default () => {
  let place = [];
  axios.get('/json/place.json').then((item) => {
    place = item.data.place;
  });
  $(function () {
    // $('.js-row').each(function () {
    //   if ($(this).find('.js-time').length === 0) {
    //     $(this).remove();
    //   }
    // });
    $('.js-place-popup').click(function () {
      const selectedUrl = $(this).text();
      if (window.innerWidth >= breakpoint) {
        $('#modal').show();
        render(<PlaceModal url={selectedUrl} open={true} onClose={()=>{$('#modal').hide();}}/>, document.getElementById('modal'));
      } else {
        place.forEach((item) => {
          if (item.exam_station_area === selectedUrl){
            location.href = `https://www.google.co.jp/maps/place/${item.exam_station_address}`;
          }
        })
      }
    })
  });
}